<template>
  <!-- <div> -->
  <b-form-group
    :id="formGroupId"
    :label="label"
    :label-for="id"
    label-class="label-bold"
    :invalid-feedback="errorMsg"
    :state="state"
  >
    <!-- accept=".jpg,.jpeg,.png" -->
    <div class="image-file-field--small-screen">
      <b-form-file
        plain
        v-model="image.file"
        accept=".jpg,.jpeg,.png"
        :placeholder="placeholder"
        @change="doSelectedImage"
        :state="state"
        :disabled="isDisabled"
      ></b-form-file>
    </div>

    <div class="image-file-field--large-screen">
      <b-form-file
        v-model="image.file"
        accept=".jpg,.jpeg,.png"
        :placeholder="placeholder"
        @change="doSelectedImage"
        :state="state"
        :disabled="isDisabled"
      ></b-form-file>
    </div>

    <div v-if="image.src" class="image-file-field__selected-image">
      <img :src="image.src" width="100%" height="100%" />
    </div>
  </b-form-group>
  <!-- </div> -->
</template>

<script>
// Image file validation functions
const MAX_SIZE_ON_DISK_MB = 10; // in MB
const MIN_WIDTH = 1000; // in px

function isTooLarge(image) {
  if (image.size > MAX_SIZE_ON_DISK_MB * 1024 * 1024) {
    return true;
  }
  return false;
}
function isImage(image) {
  if (/(png|jpe?g?)$/i.test(image.filename)) {
    return true;
  }
  return false;
}
function filenameUnique(image, arrAllImageNames) {
  if (arrAllImageNames.includes(image.filename)) {
    return false;
  }
  return true;
}
function isTooNarrow(image) {
  console.log('IMAGE WIDTH', image.width);
  if (image.width < MIN_WIDTH) {
    return true;
  }
  return false;
}
// End image file validation functions

import { mapGetters } from 'vuex';

export default {
  name: 'ImageFileField',
  props: ['id', 'label', 'placeholder', 'state', 'errorMsg', 'disabled'],
  data: function () {
    return {
      image: {
        file: null,
        filename: '',
        src: '',
        size: '',
        height: '',
        width: '',
      },
      validationError: '',
    };
  },
  computed: {
    ...mapGetters('uploadTracker', ['imageNamesAll']),
    formGroupId: function () {
      return this.id + '-group';
    },
    isDisabled: function () {
      return this.disabled;
    },
  },
  methods: {
    doSelectedImage: function (e) {
      this.resetImage();
      this.resetImageValidator();
      var selectedFile = e.target.files[0];
      if (!selectedFile) {
        // Emit here the reset (see lines above) image and image validator. Do this so if there was an error with a selected image,
        // and the user goes to select another image but hits 'cancel' in the file explorer dialog box, the previous error state of the
        // file input field is cleared (instead of remaining in red with the previous error text displayed).
        this.emitImageSelected();
        return;
      }

      // Remove all non-English-centric \w characters (so that filename parsing regex in CF (parseFileName) doesn't burp)
      // var regex = /[^-_.a-z0-9]/gi; // re-written, next line (more succinct)
      // var regex = /[^-.\w]/gi;
      // this.image.filename = selectedFile.name.replace(regex, '');
      this.image.filename = selectedFile.name.toLowerCase();

      this.image.size = selectedFile.size;

      // Do this one validation check here: If selected file is not an image, don't want to read in the file and display broken image.
      // This keeps the area on the UI where the selected image WOULD appear (right below the file input field) blank.
      if (!isImage(this.image)) {
        this.validationError = 'File must be a png or jpg image file.';
        this.emitImageSelected();
        return;
      }

      var reader = new FileReader();
      reader.readAsDataURL(selectedFile);
      var vm = this;

      reader.onload = function () {
        // NOTE: In this function, 'this' is ref to the reader obj

        var dataUrl = this.result;
        vm.image.src = dataUrl; // see template: Image conditionally shown when image.src has a value

        var image = document.createElement('img'); // Create image element to load src data to grab width/height values below
        image.src = dataUrl;

        image.onload = function () {
          // NOTE: In this function, 'this' is ref to the image obj

          vm.image.height = this.height;
          vm.image.width = this.width;
          vm.validateImage();
          vm.emitImageSelected();
        };
      };
    },

    emitImageSelected: function () {
      this.$emit('image-selected', {
        image: this.image,
        validationError: this.validationError,
      });
    },

    // Validate the selected image
    validateImage: function () {
      var { image } = this;

      // isImage check done early in doSelectedImage() since if NOT an image, don't want to read in the file and display broken image.

      if (!filenameUnique(image, this.imageNamesAll)) {
        this.validationError =
          'Image filenames must be unique; you already uploaded an image with that filename.';
        return;
      }
      if (isTooLarge(image)) {
        this.validationError = `Image too large. Must be less than ${MAX_SIZE_ON_DISK_MB}MB.`;
        return;
      }
      if (isTooNarrow(image)) {
        this.validationError = `Image not wide enough. Must be at least ${MIN_WIDTH} pixels wide.`;
        return;
      }
      this.validationError = '';
      return;
    },

    resetImage: function () {
      this.image = { file: null, src: '' };
    },
    resetImageValidator: function () {
      this.validationError = '';
    },
  },
};
</script>

<style scoped>
/* .image-file-field--large-screen  */
.image-file-field--large-screen {
  display: none;
}

.image-file-field__selected-image {
  width: 75%;
  max-width: 400px;
  margin: 1rem auto;
}

@media (min-width: 568px) {
  .image-file-field--large-screen {
    display: block;
  }
  .image-file-field--small-screen {
    display: none;
  }
  .image-file-field__selected-image {
    width: 50%;
  }
}
</style>